import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Modal } from 'react-bootstrap';
import { FaTrophy, FaGift, FaTicketAlt, FaCheckCircle, FaCrown } from 'react-icons/fa';
import { MdCelebration } from 'react-icons/md';
import { BsStarFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { JoinLuckyDraw, getUserLuckyDraws, myluckydraw } from '../../store/slices/luckydraw';
import { Link } from 'react-router-dom';

export default function UserLuckyDraw() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(2480);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('success');
  const [modalMessage, setModalMessage] = useState('');
  const [activeDraws, setActiveDraws] = useState([]);
  const [myDraws, setMyDraws] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setPageLoading(true);

      const [drawRes, myDrawRes] = await Promise.all([
        dispatch(getUserLuckyDraws()),
        dispatch(myluckydraw())
      ]);

      if (
        drawRes?.type?.includes('/fulfilled')
      ) {
        const draws = drawRes.payload.data || [];

        setActiveDraws(draws);

        const participants = draws.reduce(
          (sum, item) => sum + (item.totalParticipants || 0),
          0
        );

        setCount(participants);
      }

      // My Draws
      if (
        myDrawRes?.type?.includes('/fulfilled')
      ) {
        const joinedDraws =
          myDrawRes.payload.data || [];

        setMyDraws(joinedDraws);


      }
    } catch (error) {
      console.log(error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleJoin = async () => {
    setLoading(true);

    try {
      const response = await dispatch(
        JoinLuckyDraw()
      );

      if (
        response?.type?.includes('/rejected')
      ) {
        setModalMessage(
          response?.payload?.message ||
          response?.payload ||
          'Something went wrong.'
        );

        setModalType('error');
        setShowModal(true);
        return;
      }

      setModalType('success');
      setShowModal(true);

      await loadData();
    } catch (err) {
      setModalMessage(
        err?.message ||
        'Something went wrong.'
      );

      setModalType('error');
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };



  return (
    <>


      <div className="breadcrumb-bar mb-2 mx-1">
        <div className="container-fluid">
          <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/user/home" className="breadcrumb-link active my-2">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"
              // onClick={() => navigate("/user/luckdraw")}
              >
                Lucky draw
              </span>
            </div>

            {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >
                            <i className="bi bi-list-ul me-2"></i>
                            Projectlist
                        </button> */}

          </div>
        </div>
      </div>

      <div className="ld2-page px-3">
        <Container fluid="xl" className="mt-4 ">
          <Row className="g-2">
            {activeDraws.map((draw) => (
              <Col
                key={draw._id}
                xs={12}
                md={6}
                lg={4}
                className="mb-4"
              >
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body d-flex flex-column text-center">

                    <h4
                      className="fw-bold mb-3"
                      style={{
                        minHeight: "60px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      {draw.title}
                    </h4>

                    <p className="text-muted mb-4">
                      Draw Date:
                      <br />
                      {new Date(draw.drawDate).toLocaleDateString()}
                      <br />
                      Entry Fee: ₹{draw.amount}
                    </p>

                    <Row className="g-2 mb-4">
                      <Col xs={4}>
                        <div className="ld2-stat-card h-100">
                          <div className="ld2-stat-value">
                            {draw.totalParticipants || 0}
                          </div>
                          <div className="ld2-stat-label">
                            Participants
                          </div>
                        </div>
                      </Col>

                      <Col xs={4}>
                        <div className="ld2-stat-card h-100">
                          <div className="ld2-stat-value">
                            ₹{draw.amount}
                          </div>
                          <div className="ld2-stat-label">
                            Entry Fee
                          </div>
                        </div>
                      </Col>

                      <Col xs={4}>
                        <div className="ld2-stat-card h-100">
                          <div className="ld2-stat-value">
                            {draw.month}/{draw.year}
                          </div>
                          <div className="ld2-stat-label">
                            Month
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <Button
                      className="mt-auto"
                      onClick={() => handleJoin(draw._id)}
                      disabled={loading}
                    >
                      {loading ? (
                        "Joining..."
                      ) : (
                        <>
                          <MdCelebration className="me-2" />
                          Join Lucky Draw
                        </>
                      )}
                    </Button>

                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>

      </div>


      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        contentClassName="ld2-modal-content"
      >
        <div className={`ld2-modal-header${modalType === 'error' ? ' ld2-modal-header--error' : ''}`}>
          <span>{modalType === 'success' ? "🎉 You're In!" : 'Oops!'}</span>
        </div>

        <Modal.Body className="ld2-modal-body">
          {modalType === 'success' ? (
            <div className="text-center">
              <FaCheckCircle className="ld2-modal-success-icon" />
              <p className="ld2-modal-msg">
                Your entry has been confirmed. Good luck — fingers crossed! 🤞
              </p>
              <div className="ld2-ticket-pill">
                <FaTicketAlt /> Entry #{count.toLocaleString()}
              </div>
            </div>
          ) : (
            <div className="text-center">
              <p className="ld2-modal-msg">{modalMessage}</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="ld2-modal-footer">
          <Button className="ld2-modal-btn" onClick={() => setShowModal(false)}>
            {modalType === 'success' ? 'Awesome!' : 'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}